import { mapState, mapActions, mapMutations } from 'vuex';
import FreeWagers from '../components/FreeWagers';

export const leagueListMixin = {
  components: { FreeWagers },
  watch: {
    activeNav: {
      handler(value, before) {
        if (value || before) {
          const chosenLeague = JSON.stringify(value || before);
          localStorage.setItem('chosenLeague', chosenLeague);
        }
        value = value ? value : before;
        if (!value) {
          const chosenLeague = localStorage.getItem('chosenLeague');
          value = JSON.parse(chosenLeague);
        }
        if (value.id === this.activeMenu.id) return;
        if (!!value.icon && (value.icon.toLowerCase() === 'countries' || value.icon.toLowerCase() === 'featured')) {
          this.setActiveMenu(this.activeMenu);
          return;
        }
        if (this.hasSearchResult) {
          if (value.league_id) {
            this.selectLeague(value);
            if (value.parent) {
              this.setActiveCountry(value.parent.id);
            }
          } else {
            this.openCountry(value);
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      activeCountry: state => state.sportMenu.activeCountry,
      activeMenu: state => state.sportMenu.activeMenu,
      activeNav: state => state.sportMenu.activeNav,
      activeLeagueId: state => state.sportMenu.activeLeagueId,
      hasSearchResult: state => state.helper.hasSearchResult,
    }),
  },
  methods: {
    ...mapActions({
      setActiveLeague: 'sportMenu/setActiveLeague',
      setActiveNav: 'sportMenu/setActiveNav',
      setActiveMenu: 'sportMenu/setActiveMenu',
      setHasSearchResult: 'helper/setHasSearchResult',
    }),
    ...mapMutations({
      setActiveCountry: 'sportMenu/setActiveCountry',
      clearSelectedMarkets: 'betLines/clearSelectedMarkets',
    }),
    openCountry: function(country, isClicked) {
      this.clearSelectedMarkets();
      this.setActiveCountry(country.id);
      let leagueIds = '';
      country.children.map(item => {
        if (item.visible) leagueIds += item.league_id + ',';
      });
      leagueIds = leagueIds.endsWith(',') ? leagueIds.slice(0, -1) : leagueIds;
      this.setActiveLeague(leagueIds);
      this.setActiveNav(country);
      this.$router.replace(
        '/sports/' +
          country.url
            .split('/')
            .slice(2)
            .join('/'),
      );
      if (isClicked) {
        this.setHasSearchResult(false);
      } else {
        if (!!this.$route.params.id && this.$route.params.id !== 'undefined' && this.$route.name === 'sports.games') {
          this.$router.push(`/sports/${this.$route.params.id}`);
        } else {
          this.$router.replace(
            '/sports/' +
              country.url
                .split('/')
                .slice(2)
                .join('/'),
          );
        }
      }
    },
    selectLeague: function(leg, isClicked) {
      this.clearSelectedMarkets();
      if (leg.countryId) {
        this.setActiveCountry(leg.countryId);
      } else if (!isClicked) {
        this.setActiveCountry(0);
      }

      this.setActiveLeague(leg.league_id);
      this.setActiveNav(leg);
      this.$router.replace(
        '/sports/' +
          leg.url
            .split('/')
            .slice(2)
            .join('/'),
      );
      if (isClicked) {
        this.setHasSearchResult(false);
      } else {
        if (!!this.$route.params.id && this.$route.params.id !== 'undefined' && this.$route.name === 'sports.games') {
          this.$router.push(`/sports/${this.$route.params.id}`);
        } else {
          this.$router.replace(
            '/sports/' +
              leg.url
                .split('/')
                .slice(2)
                .join('/'),
          );
        }
      }
    },
  },
};
